export default "__VITE_ASSET__DYQz72Me__"